// Stage 81-polish — the field-focus guard for the shell keydown dispatcher.
//
// Uses event.composedPath(), NOT event.target. A key pressed inside a
// shadow-root-nested field (cos-mention-textarea's contenteditable `.editor`,
// or a composer's own `<textarea>`/`<input>` rendered in shadow DOM) has its
// `event.target` RETARGETED to the shadow host by the time a document-level
// listener runs — so `target.matches('input, …')` misses the real field and
// the Stage 72 shell guard leaks single-key page shortcuts mid-typing (the
// Stage 81 fast-path bug: typing "n"/"t"/"r"/… fired ticket shortcuts).
//
// composedPath() walks the full pre-retargeting path through every shadow
// boundary; if ANY node in it is an editable field, focus is in a field. This
// is global — it repairs every shadow-nested composer at once (customer-thread
// textarea, mail compose, conversation topic inputs, …), latently broken since
// Stage 72.

const FIELD_SELECTOR =
	'input, textarea, select, [contenteditable=true], [contenteditable=""]';

/** True when the event's composed path passes through an editable field. */
export function eventTargetsField(e: Event): boolean {
	return e.composedPath().some(
		(n) => n instanceof Element && typeof n.matches === 'function' && n.matches(FIELD_SELECTOR),
	);
}
